/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-boolean-value */
import React, { useContext, useEffect, useState } from "react";
import utils from "utils";
import { UmbracoDirectChildren, UmbracoContext } from "components/Umbraco/UmbracoContext";
import SectorItem from "./SectorItem";

const { UmbracoUtills, rest } = utils;

export default function SectorList({ mode, riskLevel, anserOld, textRecommended, selectedItem, setSelectedItem, sectorOnChange }) {

  const resourceChildren = UmbracoDirectChildren(useContext(UmbracoContext).resource);
  const [sectorList, SetSectorList] = useState([]);

  useEffect(() => {
    getSectorTypes();
  }, []);

  const getSectorTypes = async () => {
    const result = await rest.get("/api/Manager/GetSectorTypes");
    SetSectorList(result.data);
  };

  const getSectorItem = (sector) => {
    let item = "";
    for (let i = 0; i < sectorList.length; i++) {
      if (sectorList[i].SectorCode == +sector) {
        item = { ...sectorList[i] };
      }
    }
    return item;
  };

  const sectorChange = (obj) => {
    sectorOnChange(obj);
  }

  return (
    <>
      {sectorList.length ? resourceChildren.map((sec, i) => (
        <SectorItem
          item={getSectorItem(UmbracoUtills.getValueByKey(sec, "code"))}
          i={i}
          anserOld={anserOld}
          setSelectedItem={setSelectedItem}
          selectedItem={selectedItem}
          textRecommended={textRecommended}
          sectorChange={sectorChange}
          mode={mode}
          riskLevel={riskLevel}
        />
      )) : null }
    </>
  );
}
